import { Box, styled } from '@mui/material';

export const GanttPageContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  display: 'flex',
  paddingLeft: '78px',
  paddingRight: '16px',
  paddingTop: theme.spacing(1),
  width: '100vw',
  height: '100%',
  gap: theme.spacing(3),
  marginRight: theme.spacing(1),
  overflow: 'auto',
  [theme.breakpoints.down('sm')]: {
    width: '100dvw',
    flexDirection: 'column',
    paddingLeft: '16px',
    paddingTop: '6.5dvh',
    padingRight: '16px',
    paddingBottom: theme.spacing(1),
    gap: 0,
    height: '100dvh',
    overflowY: 'auto',
  },
  [theme.breakpoints.up('sm')]: {
    padingRight: '0',
  },
  '@media print': {
    marginLeft: '0',
    width: '210mm',
    paddingLeft: '0',
    overflow: 'visible',
  },
}));
